/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Forbidden_DescInputs */

const vi_packaging_forbidden_desc = /** @type {(inputs: Packaging_Forbidden_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ quản trị để được cấp quyền packaging.read.`)
};

/**

* @param {Packaging_Forbidden_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_forbidden_desc = /** @type {((inputs?: Packaging_Forbidden_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Forbidden_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_forbidden_desc(inputs)
});